import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Paper,
  Tooltip,
  Typography,
  withStyles
} from '@material-ui/core'
import { Cancel, CheckCircle, Error } from '@material-ui/icons'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'
import { formatDate } from '../../../utils/Formatter'
import flexRepository from './flexRepository'

const styles = theme => ({
  paper: {
    padding: 8
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    color: theme.palette.getContrastText(theme.palette.success.dark)
  },
  warning: {
    backgroundColor: theme.palette.warning.dark,
    color: theme.palette.getContrastText(theme.palette.success.dark)
  },
  error: {
    backgroundColor: theme.palette.error.dark,
    color: theme.palette.getContrastText(theme.palette.error.dark)
  },
  iconSuccess: {
    width: 20,
    height: 20,
    color: theme.palette.success.dark
  },
  destaqueOk: {
    width: 16,
    height: 16,
    color: theme.palette.success.dark
  }
})

const CardFlex = ({ solicitacaoId, classes }) => {
  const [disabled, setDisabled] = useState(false)
  const [data, setData] = useState()
  const [state, setState] = useState('loading')
  const [message, setMessage] = useState('')
  const [trigger, setTrigger] = useState(false)

  const fetchData = useCallback(async () => {
    setState('loading')
    const response = await flexRepository.getBySolicitacaoId(solicitacaoId)
    if (response.ok) {
      const data = response.data
      setData(data)
      setDisabled(true)
      switch (data.statusRequisicao) {
        case 0:
          setMessage('Falha na consulta')
          setState('error')
          break
        case 1:
          setState('success')
          break
        case 2:
          setState('loading')
          setMessage('Pendente Flex')
          break
        default:
          setMessage('Falha na consulta')
          setState('error')
          break
      }
    } else {
      setMessage('Falha na consulta')
      setState('error')
    }
  }, [solicitacaoId])

  useEffect(() => {
    fetchData()
  }, [trigger, fetchData])

  const handleManualFetch = async () => {
    setState('loading')
    const response = await flexRepository.consultar(solicitacaoId)
    if (response.ok) {
      setTrigger(!trigger)
    } else {
      setState('error')
      setMessage('Falha ao consultar')
    }
  }

  const renderStatus = statusNum => {
    let classe = classes.error
    let status = 'Bloqueado'
    switch (statusNum) {
      case '0':
        status = 'Ativo'
        classe = classes.success
        break
      case '1':
        status = 'Vencido'
        classe = classes.warning
        break
      case '2':
        status = 'Bloqueado'
        classe = classes.error
        break
      default:
        break
    }
    return <Chip size="small" label={status} className={classe} />
  }

  const renderCard = (transportadora, historico) => {
    if (historico && historico.length) {
      const ultimaViagem = historico[0]
      const quantidadeUltimos = historico.filter(viagem => {
        return moment().diff(moment(viagem.dataViagem), 'days') <= 90
      })
      return (
        <Paper className={classes.paper}>
          <Typography variant="body1" noWrap>
            <b>{transportadora}</b>
          </Typography>
          <Box p={1}>
            <Typography variant="caption" display="block">
              Quantidade: {historico.length}
            </Typography>

            <Grid container alignItems="center">
              <Typography variant="caption" display="inline">
                Quantidade 90 dias: {quantidadeUltimos.length}
              </Typography>
              {quantidadeUltimos.length > 0 && (
                <CheckCircle className={classes.destaqueOk} color="inherit" />
              )}
            </Grid>
          </Box>
          <Typography variant="body2" display="block">
            <b>Última Viagem</b>
          </Typography>
          <Box p={1}>
            <Typography variant="caption" display="block">
              Status Motorista: {renderStatus(ultimaViagem?.statusMotorista)}
            </Typography>
            <Typography variant="caption" display="block">
              Data: {formatDate(ultimaViagem?.dataViagem)}
            </Typography>
            <Typography variant="caption" display="block">
              Mercadoria: {ultimaViagem?.mercadoria}
            </Typography>
            <Typography variant="caption" display="block">
              Placa: {ultimaViagem?.placaCavalo}
            </Typography>
            <Typography variant="caption" display="block">
              Proprietário: {ultimaViagem?.nomeProprietario}
            </Typography>
            <Typography variant="caption" display="block">
              CPF/CNPJ Proprietário: {ultimaViagem?.cpfCnpjProprietario}
            </Typography>
            <Typography variant="caption" display="block" noWrap>
              Rota: {ultimaViagem?.cidadeOrigem} x {ultimaViagem?.cidadeDestino}
            </Typography>
          </Box>
        </Paper>
      )
    }
    return null
  }

  const renderCards = () => {
    if (data) {
      if (
        !data.historicoViagem ||
        Object.keys(data.historicoViagem).length === 0
      ) {
        return (
          <Typography variant="h6" align="center">
            Nenhum Histórico de Viagem!
          </Typography>
        )
      }
      return (
        <Grid container spacing={4}>
          {Object.keys(data.historicoViagem).map(transportadora => (
            <Grid item xs={12} sm={3} key={transportadora}>
              {renderCard(transportadora, data.historicoViagem[transportadora])}
            </Grid>
          ))}
        </Grid>
      )
    }
    return null
  }

  const renderEstadoConsulta = () => {
    return (
      <Grid container spacing={4} alignItems="center">
        <Grid item>
          {(state === 'error' || state === 'loading') && (
            <Tooltip placement="top" title={message}>
              {message === 'Falha na consulta' ? (
                <Cancel color="secondary" />
              ) : (
                <Error color="secondary" />
              )}
            </Tooltip>
          )}
          {state === 'success' && (
            <CheckCircle className={classes.iconSuccess} color="inherit" />
          )}
          {state === 'loading' && <CircularProgress size={24} />}
        </Grid>

        <Grid item>
          <Button
            variant="outlined"
            onClick={handleManualFetch}
            disabled={state === 'loading' || disabled}
            color="primary"
          >
            Consultar
          </Button>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container spacing={4}>
      <Grid item>
        <Grid container alignItems="center">
          <Grid item>
            <Typography
              variant="h6"
              display="inline"
              style={{ marginRight: 4 }}
            >
              Consulta Flex
            </Typography>
          </Grid>
          <Grid item>{renderEstadoConsulta()}</Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {renderCards()}
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(CardFlex)
